import { render, staticRenderFns } from "./communicate-data.vue?vue&type=template&id=f68b2a40"
import script from "./communicate-data.vue?vue&type=script&lang=ts"
export * from "./communicate-data.vue?vue&type=script&lang=ts"
import style0 from "./communicate-data.vue?vue&type=style&index=0&id=f68b2a40&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports